import React from "react";
import { Sort, ArrowUpward, ArrowDownward } from "@mui/icons-material";

/**
 * Returns the appropriate sort icon based on current sort state
 * @param {string} sortBy - Current field being sorted
 * @param {string} sortOrder - Current sort order ('asc' or 'desc')
 * @param {string} field - Field to check against
 * @returns {JSX.Element} Sort icon component
 */
export const getSortIcon = (sortBy, sortOrder, field) => {
  if (sortBy !== field) {
    return <Sort fontSize="small" sx={{ opacity: 0.5 }} />;
  }
  return sortOrder === "asc" ? (
    <ArrowUpward fontSize="small" />
  ) : (
    <ArrowDownward fontSize="small" />
  );
};
